// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import { Checkbox } from 'grab-ui';
import { Dropdown, Menu } from 'semantic-grab-ui/src';

type Props = {
  options: Array<string>,
  selected: Array<string>,
  maxSelectable: number,
  onSelect: Function, // callback function that receives an array of items selected
  entity: string,
};

// MetricMultiSelectDropdown is a multi-select dropdown for selecting items
export default class MetricMultiSelectDropdown extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      choices: props.selected || [],
    };
  }

  isOptionDisabled = (option: string) => {
    const isSingleOptionLeft = this.state.choices.length === 1 && this.state.choices[0] === option;
    return (this.state.choices.length >= this.props.maxSelectable && !_.includes(this.state.choices, option)) || isSingleOptionLeft;
  };

  handleSelect = (option: string) => {
    const { choices } = this.state;
    if (!_.includes(choices, option)) {
      choices.push(option);
    } else {
      _.remove(choices, x => x === option);
    }

    this.setState({
      choices,
    });

    if (this.props.onSelect) {
      this.props.onSelect(choices);
    }
  };

  render() {
    const { choices } = this.state;
    const entityCapitalize = _.capitalize(this.props.entity);
    let dropdownText = `${choices.length} ${entityCapitalize + (choices.length > 1 ? 's' : '')}`;
    if (choices.length === this.props.options.length) {
      dropdownText = this.props.options.length === 1 ? this.props.options[0] : `All ${entityCapitalize}s (${choices.length})`;
    }
    const canSelectAll = this.props.options.length <= this.props.maxSelectable;

    return (
      <Menu compact style={this.props.style}>
        <Dropdown
          text={dropdownText}
          item
          selection
          style={{ zIndex: 10 }}
        >
          <Dropdown.Menu style={{ maxHeight: 1000, zIndex: 10, minWidth: canSelectAll ? 0 : 245 }}>
            {
              !canSelectAll &&
                <p style={{ margin: '16px 16px 12px 16px', color: '#707070', fontSize: 12 }}>Select max. {this.props.maxSelectable} {entityCapitalize}s to view together</p>
            }
            {
              _.map(this.props.options, option => {
                return (<Dropdown.Item>
                  <Checkbox
                    disabled={this.isOptionDisabled(option)}
                    checked={_.includes(choices, option)}
                    onChange={() => this.handleSelect(option)}
                    style={{ width: '100%' }}
                  >
                    {option}
                  </Checkbox>
                </Dropdown.Item>);
              })
            }
          </Dropdown.Menu>
        </Dropdown>
      </Menu>
    );
  }
}
